import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class EnquiryService {

  constructor(private globalHelper:GlobalHelper, private httpclient: HttpClient) { }

   // APPOINTMENT

   GetAllMeeting(strData:any):Observable<any>{   
      let data='ObjEnquiry=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/GetAllMeeting?'+encodeURI(data),{headers:reqHeader});

}

SaveMeetingAddNote(strData:any):Observable<any> {
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveMeetingAddNote?'+encodeURI(data),{headers:reqHeader});
}

GetMeetingAddNote(strData:any):Observable<any> {
    let data='ObjEnquiry=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/GetMeetingAddNote?'+encodeURI(data),{headers:reqHeader});
}

GetAllProspectus(strData:any) :Observable<any> {
       let data='ObjEnquiry=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/GetAllProspectus?'+encodeURI(data),{headers:reqHeader});

}

// RECEPTION

SearchAllEnquiry(strData:any) :Observable<any> {
    let data='SearchModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SearchAllEnquiry?'+encodeURI(data),{headers:reqHeader});
}

SearchAllVisitor (strData:any) :Observable<any> {
     let data='SearchModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SearchAllVisitor?'+encodeURI(data),{headers:reqHeader});
}

GetMeetingsByEnquiry(strData:any):Observable<any> {
   

    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/GetMeetingsByEnquiry?'+encodeURI(data),{headers:reqHeader});

}

SaveEnquiry(strData:any) :Observable<any> {
   
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveEnquiry?'+encodeURI(data),{headers:reqHeader});
    
}

SaveVisitorLog(strData:any):Observable<any> {
       
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveVisitorLog?'+encodeURI(data),{headers:reqHeader});
   

}

SaveVisitor (strData:any) :Observable<any> {

    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveVisitor?'+encodeURI(data),{headers:reqHeader});
   
}

SaveMeetingSchedule(strData:any):Observable<any> {

   
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveMeetingSchedule?'+encodeURI(data),{headers:reqHeader});
    
}


SaveEnquiryAddNote(strData:any) :Observable<any> {

    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveEnquiryAddNote?'+encodeURI(data),{headers:reqHeader});
    
}

SaveEnqIssueProspectus (strData:any) :Observable<any> {

    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveEnqIssueProspectus?'+encodeURI(data),{headers:reqHeader});
    

}

GetAddNoteByEnquiry(strData:any) :Observable<any> {
       let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/GetAddNoteByEnquiry?'+encodeURI(data),{headers:reqHeader});
    
}

// Enquiry Type
GetAllEnquiryType ():Observable<any> {
     
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/GetAllEnquiryType',{headers:reqHeader});
    

}

SaveEnquiryType(strData:any):Observable<any> {
   
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/SaveEnquiryType?'+encodeURI(data),{headers:reqHeader});
    
}

EnquiryTypeMarkActive (strData:any):Observable<any> {
     
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/EnquiryTypeMarkActive?'+encodeURI(data),{headers:reqHeader});
  
}

VisitorRegistor (strData:any):Observable<any> {
   

    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/VisitorRegistor?'+encodeURI(data),{headers:reqHeader});
  
}
UpdateEnquiryStatus  (strData:any):Observable<any> {       
    let data='ObjModel=' +strData;  
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Enquiry/UpdateEnquiryStatus?'+encodeURI(data),{headers:reqHeader});  
   
}


}
